import { imageFallback } from './styles';

export const ImageFallbackIcon = () => {
  return (
    <svg
      className={imageFallback}
      width="49"
      height="38"
      viewBox="0 0 49 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.2965 5.46606H45.0023C46.9344 5.46606 48.5009 7.02493 48.5007 8.94772V34.1567C48.5007 36.0797 46.9344 37.6385 45.0023 37.6385H3.99905C2.06691 37.6385 0.500732 36.0797 0.500732 34.1567V8.94772C0.500732 7.02493 2.06691 5.46606 3.9992 5.46606H13.7048L16.2704 1.17637C16.5213 0.756962 16.9755 0.5 17.466 0.5H31.5353C32.0258 0.5 32.4799 0.756962 32.7309 1.17637L35.2965 5.46606ZM14.5427 21.5521C14.5427 27.0257 19.001 31.4627 24.5007 31.4627C30.0003 31.4627 34.4586 27.0257 34.4586 21.5521C34.4586 16.0788 30.0003 11.6415 24.5007 11.6415C19.001 11.6415 14.5427 16.0788 14.5427 21.5521Z"
        fill="#BFC3C3"
      />
    </svg>
  );
};
